export const captcha_key = "6Lce7eEjAAAAAN4NP1y71ucVlQJb1AV0pxd7_qFQ"
